<script lang="ts">
	import { LoaderCircle } from 'lucide-svelte';
</script>

<LoaderCircle class="animate-spin size-4 stroke-muted-foreground" />
